<template>
  <BaseInput
      v-bind="$attrs"
      type="text"
      class="mb-4 d-block"
      :value="value"
      placeholder="Pesquisa por CPF, CNPJ ou e-mail"
      @input="onInput"
  />
</template>

<script>
import BaseInput from '@/components/BaseInput.vue';

export default {
  name: 'ClientIdentifierInput',
  components: { BaseInput },
  inheritAttrs: false,
  props: {
    value: [String, Number]
  },
  data() {
    return {
      type: null
    };
  },
  methods: {
    onInput(e) {
      this.$emit('input', e);
      this.type = this.updateType(e);
      this.passTypeForParent();
    },
    passTypeForParent(){
      this.$emit('update:type', this.type);
    },
    updateType(value){
      let unmaskedValue = value?.replace(/[.\-\/]/g, '');

      if (unmaskedValue && /\D/.test(unmaskedValue)) {
        return 'email';
      }

      if (unmaskedValue && unmaskedValue.length > 11) {
        return 'cnpj';
      }

      if (unmaskedValue && unmaskedValue.length <= 11) {
        return 'cpf';
      }

      return null;
    }
  }
}
</script>